import { Box, Button } from "@chakra-ui/react";
import ErrorDetails from "components/ErrorDetails";
import useTranslate from "hooks/useTranslate";

const FancyBearsEmptyMessage = () => {
  const translate = useTranslate();

  return (
    <Box bg="bright.400" py="12" px="12" maxW="xs">
      <ErrorDetails
        title={translate("fancyBears:empty:title")}
        description={translate("fancyBears:empty:description")}
      >
        <a
          href="https://opensea.io/collection/fancybearsmetaverseofficial"
          target="_blank"
          rel="noreferrer"
          style={{
            display: "block",
            width: "100%",
          }}
        >
          <Button as="span" colorScheme="secondary" w="full">
            {translate("common:buyOnOpenSea")}
          </Button>
        </a>
      </ErrorDetails>
    </Box>
  );
};

export default FancyBearsEmptyMessage;
